import { withResources } from '@/common/resources';

import { ErrorBoundary as Base } from './ErrorBoundary';

export const ErrorBoundary = withResources(Base, ({ resource }) => ({
  resource: {
    anErrorHasOccurred: resource?.anErrorHasOccurred ?? '',
  },
}));
